<mat-dialog-actions>
  <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<div class="container">
  <div   cdkDrag   cdkDragHandle cdkDragRootElement=".cdk-overlay-pane"  class="title" >
        {{ dialogSettings.actionHeader|translate }}
    </div>
    <p cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" style="white-space: pre-line;">
        {{ dialogSettings.actionBody|translate }}
    </p>
    <div class="button-block">
      <button (click)="submitAction()"  class="button-icon primary-button size-l"  type="submit" >
        {{ !dialogSettings.cancelButtonHide ? ((dialogSettings?.buttonLabel||'CONFIRM.BUTTONS.YES') | translate) : ('MODALS.BUTTONS.CLOSE'|translate) }}
      </button>
      <button (click)="cancelAction()" *ngIf="!dialogSettings.cancelButtonHide" class="button-icon secondary-button size-l">
        {{ 'CONFIRM.BUTTONS.CANCEL'|translate }}
      </button>
    </div>
</div> 
